module.exports = __webpack_public_path__ + "static/media/breacher-info.dbd9046e.jpg";